import React, { Component, PropTypes } from 'react'
import { AlertErrorOutline, ActionCheckCircle } from 'material-ui/svg-icons'
import ClearIcon from 'material-ui/svg-icons/content/clear'

const styles = {
  errorIcon: {
    verticalAlign: 'middle',
    display: 'inline-block',
    marginRight: '15px',
    color: '#F55649'
  },
  successIcon: {
    verticalAlign: 'middle',
    display: 'inline-block',
    marginRight: '15px',
    color: '#5FB762'
  },
  iconText: {
    verticalAlign: 'middle',
    display: 'inline-block'
  },
  errorMessageBox: {
    display: 'block',
    boxShadow: 'none',
    color: '#621B16',
    border: '1px solid #F44336',
    padding: '10px',
    borderRadius: '5px'
  },
  successMessageBox: {
    display: 'block',
    boxShadow: 'none',
    color: '#1F4620',
    border: '1px solid #4CAF50',
    padding: '10px',
    borderRadius: '5px'
  },
  errorDismissIcon: {
    color: '#7A3E3A',
    fontSize: '14px',
    verticalAlign: 'middle',
    display: 'inline-block',
    float: 'right'
  },
  successDismissIcon: {
    color: '#1F4620',
    fontSize: '14px',
    verticalAlign: 'middle',
    display: 'inline-block',
    float: 'right'
  }
}

class Alert extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      visible: true
    }
  }

  generateIcon () {
    switch (this.props.type) {
      case 'error':
        return (
          <AlertErrorOutline style={this.generateIconClass()} />
        )
      case 'success':
        return (
          <ActionCheckCircle style={this.generateIconClass()} />
        )
    }
  }

  generateIconClass () {
    switch (this.props.type) {
      case 'error': return styles.errorIcon
      case 'success': return styles.successIcon
    }
  }

  generateMessageBoxClass () {
    switch (this.props.type) {
      case 'error': return styles.errorMessageBox
      case 'success': return styles.successMessageBox
    }
  }

  generateDismissIconClass () {
    switch (this.props.type) {
      case 'error': return styles.errorDismissIcon
      case 'success': return styles.successDismissIcon
    }
  }

  handleDismiss = () => {
    this.setState({
      visible: false
    })
  }

  render () {
    return (
      <div style={{ display: 'inline' }}>
        {this.state.visible === true &&
          <div style={this.generateMessageBoxClass()}>
            {this.generateIcon()}
            <span style={styles.iconText}>
              {this.props.message}
            </span>
            <ClearIcon style={this.generateDismissIconClass()} onClick={this.handleDismiss} />
          </div>}
      </div>
    )
  }
}

// @ts-ignore
Alert.propTypes = {
  type: PropTypes.oneOf(['error', 'success']).isRequired,
  message: PropTypes.string.isRequired
}

// @ts-ignore
Alert.defaultProps = {
  type: 'success'
}

export default Alert
